import Confirm from "./Confirm";
import Permission from "./Permissions";
import Key from "./Key";

export default {
  PERMISSIONS: Permission,
  KEY: Key,
  CONFIRM: Confirm,
};
